import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';

import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';
import { WebcastQuestionOption } from 'rev-portal/scheduledEvents/webcast/WebcastStatus';
import { SimpleToolbar } from 'rev-shared/htmlEditor/Constants';

import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';

import { WebcastViewQuestionsService } from './WebcastViewQuestions.Service';

@Component({
	selector: 'vb-webcast-ask-question',
	templateUrl: './VbWebcastAskQuestion.Component.html',
	standalone: false,
	host: {
		'class': 'd-flex'
	}
})
export class VbWebcastAskQuestionComponent implements OnInit {
	@Input() public context: IWebcastViewContext;
	@Input() public webcast: WebcastModel;

	@Output() public questionAsked: EventEmitter<any> = new EventEmitter();

	public readonly WebcastQuestionOption = WebcastQuestionOption;
	public questionText: string;
	public isAnonymous: boolean;
	public processing: boolean;
	public editorConfig: CKEDITOR.config = { toolbar: SimpleToolbar };

	constructor(
		private readonly WebcastViewQuestionsService: WebcastViewQuestionsService
	) {}

	public ngOnInit(): void {
		this.reset();
	}

	public reset(): void {
		this.questionText = '';
		this.isAnonymous = this.webcast.questionOption === WebcastQuestionOption.ANONYMOUS;
		this.processing = false;
	}
	public submitQuestion(): void {
		this.processing = true;
		this.WebcastViewQuestionsService.askQuestion(this.webcast, this.questionText, this.isAnonymous)
			.then(question => {
				this.questionAsked.emit({ question });
				this.reset();
			})
			.finally(() => {
				this.processing = false;
			});
	}
}
